/**
 * Normalize legacy plan ids for entitlement and UX. Max is no longer sold;
 * existing DB rows may still use plan_id = 'max'.
 */
export function effectiveTierPlanId(planId: string): "free" | "pro" {
	if (planId === "max" || planId === "pro") return "pro";
	return "free";
}

/** Public-facing tier for UI and validations — excludes deprecated max */
export type SellableTierId = "free" | "pro";

export function toSellableTier(planId: string): SellableTierId {
	return effectiveTierPlanId(planId) === "pro" ? "pro" : "free";
}
